<template>
  <div class="like-card">
    <div class="like-header">
      <div class="like-icon">
        <i :class="iconClass" :style="iconStyle"></i>
        <span :style="type === 'mark' ? { color: '#1159AF' } : {}">{{ labelText }}</span>
        <span class="dot">•</span>
        <span class="author-wrapper">
          <span class="author-label">by</span>
          <el-avatar :size="16" :src="like.post.authorAvatar" class="author-avatar" style="font-size: 10px;">{{ like.post.author?.charAt(0) || 'U' }}</el-avatar>
          <span class="author-name">{{ like.post.author }}</span>
        </span>
        <span class="dot">•</span>
        <span class="timestamp">{{ formattedTimestamp }}</span>
      </div>
      <div class="like-actions">
        <el-button
          type="text"
          size="mini"
          icon="el-icon-view"
          @click="viewPost"
          class="view-btn"
        >
          View the Stack
        </el-button>
        <el-dropdown trigger="click" @command="handleCommand">
          <el-button type="text" size="mini" class="more-btn">
            <i class="el-icon-more"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="remove">
              <i class="el-icon-delete"></i> Remove
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    
    <div class="like-content">
      <div class="post-preview">
        <h3 class="post-title" @click="viewPost">{{ like.post.title }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LikeCard',
  props: {
    like: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'like' // 'like' or 'mark'
    }
  },
  computed: {
    iconClass() {
      return this.type === 'mark' ? 'el-icon-star-on' : 'el-icon-thumb'
    },
    iconStyle() {
      return {
        fontWeight: 'bold',
        color: '#1159AF'
      }
    },
    labelText() {
      return this.type === 'mark' ? 'Starred Stack' : 'Liked Stack'
    },
    formattedTimestamp() {
      const date = new Date(this.like.timestamp)
      const now = new Date()
      const diffInHours = Math.floor((now - date) / (1000 * 60 * 60))
      const diffInDays = Math.floor(diffInHours / 24)

      if (diffInHours < 1) {
        return 'Just now'
      } else if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`
      } else if (diffInDays <= 10) {
        return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`
      } else {
        // More than 10 days ago - show actual date
        const month = date.toLocaleString('en-US', { month: 'short' })
        const day = date.getDate()
        const year = date.getFullYear()
        const currentYear = now.getFullYear()

        if (year === currentYear) {
          return `${month} ${day}`
        } else {
          return `${month} ${day}, ${year}`
        }
      }
    }
  },
  methods: {
    viewPost() {
      // Navigate to post detail page using query params
      this.$router.push({
        path: '/stack',
        query: {
          id: this.like.post.id
        }
      })
    },
    handleCommand(command) {
      if (command === 'remove') {
        this.$emit('remove', this.like.id)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.like-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-left: 3px solid #1159AF;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #dee2e6;
  }
}

.like-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.like-icon {
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 18px;
    color: #e74c3c;
  }

  > span {
    font-weight: 600;
    color: #495057;
    font-size: 14px;
  }

  .dot {
    color: #adb5bd;
    font-size: 14px;
    font-weight: normal;
  }

  .author-wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #6c757d;
    font-weight: normal;

    .author-label {
      font-size: 12px;
    }

    .author-avatar {
      flex-shrink: 0;
    }

    .author-name {
      font-size: 12px;
    }
  }

  .timestamp {
    font-size: 12px;
    color: #6c757d;
    font-weight: normal;
  }
}

.like-actions {
  display: flex;
  gap: 8px;
  
  .view-btn {
    color: #1159AF;
    font-size: 12px;
    
    &:hover {
      color: #409EFF;
    }
  }
  
  .remove-btn {
    color: #6c757d;
    font-size: 12px;
    
    &:hover {
      color: #dc3545;
    }
  }
}

.like-content {
  .post-preview {
    .post-title {
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
      margin: 0;
      cursor: pointer;
      line-height: 1.3;
      word-wrap: normal;
      word-break: normal;
      overflow-wrap: normal;
      hyphens: none;

      &:hover {
        color: #1159AF;
      }
    }
  }
}
</style> 